import { appendScript } from "@stadium/helpers/src/script-loader";

import { SentryError } from "@stadium/services/error-reporting/utils";

import {
  CHILI_PIPER_DOMAIN,
  CHILI_PIPER_OPTIONS,
  CHILI_PIPER_JS_URL,
  CHILI_PIPER_SM_ROUTER,
  CHILI_PIPER_SWAG_ROUTER,
  CHILI_PIPER_SWAG_CATALOG_ROUTER,
  SWAGMAGIC_CATALOG,
  SNACKMAGIC,
  SWAGMAGIC,
  STADIUM,
  CHILI_PIPER_STADIUM_ROUTER,
} from "./constant";

export class ChiliPiperError extends SentryError {
  get name() {
    return "ChiliPiper Error";
  }
}

const ChiliPiperService = {
  initialize: () => {
    appendScript(CHILI_PIPER_JS_URL, () => {
      function q(a) {
        return function () {
          try {
            // eslint-disable-next-line no-undef
            ChiliPiper[a].q = (ChiliPiper[a].q || []).concat([arguments]);
          } catch (error) {
            throw new ChiliPiperError(error);
          }
        };
      }
      window.ChiliPiper =
        window.ChiliPiper ||
        "submit scheduling showCalendar submit widget bookMeeting".split(" ").reduce((a, b) => {
          a[b] = q(b);
          return a;
        }, {});
    });
  },
  getRouter: (app) => {
    switch (app) {
      case SNACKMAGIC:
        return CHILI_PIPER_SM_ROUTER;
      case SWAGMAGIC:
        return CHILI_PIPER_SWAG_ROUTER;
      case SWAGMAGIC_CATALOG:
        return CHILI_PIPER_SWAG_CATALOG_ROUTER;
      case STADIUM:
        return CHILI_PIPER_STADIUM_ROUTER;
      default:
        // eslint-disable-next-line no-console
        console.error("App name unspecified! No ChiliPiper Router Found!");
        return "";
    }
  },
  schedule: (router) => {
    if (window.ChiliPiper) {
      try {
        // eslint-disable-next-line no-undef
        ChiliPiper.scheduling(CHILI_PIPER_DOMAIN, router, CHILI_PIPER_OPTIONS);
      } catch (error) {
        throw new ChiliPiperError(error);
      }
    }
  },
  submit: (lead, router, options) => {
    if (window.ChiliPiper) {
      // eslint-disable-next-line no-undef
      ChiliPiper.submit(CHILI_PIPER_DOMAIN, router, {
        ...CHILI_PIPER_OPTIONS,
        ...options,
        lead: { ...lead },
        onError: (error) => {
          if (options?.onError) {
            options.onError(error);
          }
          throw new ChiliPiperError(error);
        },
      });
    }
  },
};

export const { initialize, schedule, submit, getRouter } = ChiliPiperService;
